// node_modules/.pnpm/@solid-primitives+utils@6.2.3_solid-js@1.8.18/node_modules/@solid-primitives/utils/dist/chunk/R5675YMU.js
import { DEV, equalFn, untrack, getOwner, onCleanup, createSignal, sharedConfig, onMount } from "solid-js";
import { isServer } from "solid-js/web";
import { isServer as isServer2 } from "solid-js/web";
function chain(callbacks) {
  return (...args) => {
    for (const callback of callbacks)
      callback && callback(...args);
  };
}

// node_modules/.pnpm/@solid-primitives+refs@1.0.8_solid-js@1.8.18/node_modules/@solid-primitives/refs/dist/index.js
import { createMemo, children, createComputed, untrack as untrack2, onCleanup as onCleanup2 } from "solid-js";
import { isServer as isServer3 } from "solid-js/web";
function mergeRefs(...refs) {
  return chain(refs);
}

// src/chart.tsx
import { Chart } from "chart.js";
import { createEffect, mergeProps, on, onCleanup as onCleanup3, onMount as onMount2, createSignal as createSignal2 } from "solid-js";
import { unwrap } from "solid-js/store";
function DefaultChart(props) {
  const [canvasRef, setCanvasRef] = createSignal2();
  const [chart, setChart] = createSignal2();
  const merged = mergeProps(
    {
      width: 512,
      height: 512,
      type: "line",
      data: {},
      options: { responsive: true },
      plugins: []
    },
    props
  );
  const init = () => {
    const ctx = canvasRef()?.getContext("2d");
    const config = unwrap(merged);
    if (config.type !== "radar") {
      if (config.options.scales?.r) {
        delete config.options.scales?.r;
      }
    }
    const chart2 = new Chart(ctx, {
      type: config.type,
      data: config.data,
      options: config.options,
      plugins: config.plugins
    });
    setChart(chart2);
  };
  onMount2(() => {
    init();
  });
  createEffect(
    on(
      () => merged.data,
      () => {
        chart().data = merged.data;
        chart().update();
      },
      {
        defer: true
      }
    )
  );
  createEffect(
    on(
      () => merged.options,
      () => {
        chart().options = merged.options;
        chart().update();
      },
      {
        defer: true
      }
    )
  );
  createEffect(
    on(
      [() => merged.width, () => merged.height],
      () => {
        chart().resize(merged.width, merged.height);
      },
      {
        defer: true
      }
    )
  );
  createEffect(
    on(
      () => merged.type,
      () => {
        const dimensions = [chart().width, chart().height];
        chart().destroy();
        init();
        chart().resize(...dimensions);
      },
      {
        defer: true
      }
    )
  );
  onCleanup3(() => {
    chart()?.destroy();
    mergeRefs(props.ref, null);
  });
  return <canvas
    ref={mergeRefs(props.ref, (el) => setCanvasRef(el))}
    height={merged.height}
    width={merged.width}
  >{merged.fallback}</canvas>;
}

// src/typedCharts.tsx
import {
  Chart as Chart2,
  LineController,
  BarController,
  RadarController,
  DoughnutController,
  PolarAreaController,
  BubbleController,
  PieController,
  ScatterController,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement
} from "chart.js";
function createTypedChart(type, registerables) {
  Chart2.register(registerables);
  return (props) => <DefaultChart type={type} {...props} />;
}
var Line = /* @__PURE__ */ createTypedChart("line", [
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
]);
var Bar = /* @__PURE__ */ createTypedChart("bar", [
  BarController,
  CategoryScale,
  BarElement
]);
var Radar = /* @__PURE__ */ createTypedChart("radar", [RadarController, RadialLinearScale]);
var Doughnut = /* @__PURE__ */ createTypedChart("doughnut", [
  DoughnutController,
  ArcElement
]);
var PolarArea = /* @__PURE__ */ createTypedChart("polarArea", PolarAreaController);
var Bubble = /* @__PURE__ */ createTypedChart("bubble", BubbleController);
var Pie = /* @__PURE__ */ createTypedChart("pie", PieController);
var Scatter = /* @__PURE__ */ createTypedChart("scatter", ScatterController);
export {
  Bar,
  Bubble,
  DefaultChart,
  Doughnut,
  Line,
  Pie,
  PolarArea,
  Radar,
  Scatter
};
